// MCS Quiz — v1.4

(function () {
  'use strict';

  var state = {
    currentStep: 0,
    totalSteps: 6,
    answers: {
      genre: null,
      age: null,
      priorite: [],
      integration: [],
      moment: [],
      routine: [],
      prenom: '',
      email: '',
      optin: false,
    },
    recommendation: null,
  };

  var scoringRules = {
    genre: {
      femme:  { pure: 1, trio: 1 },
      homme:  { energie: 1 },
      'non-binaire':  {},
      nc:     {},
    },
    age: {
      'moins25': { energie: 1 },
      '25-34':   { energie: 1, pure: 1 },
      '35-44':   { pure: 2, trio: 1 },
      '45-54':   { pure: 3, trio: 2 },
      '55plus':  { pure: 4, trio: 2 },
      nc:        {},
    },
    priorite: {
  energie:       { energie: 5 },
  beaute:        { pure: 3, trio: 4 },
  articulations: { pure: 5 },
  sommeil:       { serenite: 5 },   // new
  nc:            {},
},
integration: {
  cafe:     { pure: 3 },
  eau:      { pure: 1, energie: 1, serenite: 3 },  // updated
  jus:      { pure: 1, energie: 1 },
  smoothie: { trio: 1, pure: 1 },
  emporter: { energie: 3 },
  nc:       {},
},
moment: {
  matin:    { energie: 1 },
  journee:  { energie: 1 },
  soir:     { pure: 1, serenite: 4 },  // updated
  variable: {},
  nc:       {},
},
routine: {
  resultats:  { trio: 2, pure: 1 },
  constance:  { pure: 1, energie: 1 },
  simplicite: { pure: 1, energie: 1 },
  bienetre:   { trio: 2, pure: 2, serenite: 2 },  // updated
  nc:         {},
},
  };

  var cfg = window.MCSQuizConfig || {};
  var klaviyoPublicKey = cfg.klaviyoKey || '';
  var klaviyoListId   = cfg.klaviyoListId || '';
  var _vids   = cfg.variantIds    || {};
  var _imgs   = cfg.productImages || {};
  var _names  = cfg.productNames  || {};
  var _prices   = cfg.productPrices        || {};
  var _compare  = cfg.productComparePrices || {};
  var _urls     = cfg.productUrls          || {};
  var I18N      = cfg.i18n                  || {};

  var products = {
    pure: {
      variantId: _vids.pure || null,
      variants: (cfg.pureVariants && cfg.pureVariants.length > 1) ? cfg.pureVariants : null,
      name: _names.pure,
      benefit: I18N.benefitPure || 'Peau, cheveux, ongles & articulations — le collagène marin essentiel.',
      price: '60,00 $',
      image: _imgs.pure || null,
      url: _urls.pure || '/fr-ca/products/collagene-marin-pure',
    },
    energie: {
      variantId: _vids.energie || null,
      name: _names.energie,
      benefit: I18N.benefitEnergie || 'Énergie, performance & récupération — la formule boostée.',
      price: _prices.energie || '80,00 $',
      compareAtPrice: _compare.energie || null,
      image: _imgs.energie || null,
      url: _urls.energie || '/fr-ca/products/collagene-energie',
    },
    trio: {
      variantId: _vids.trio || null,
      name: _names.trio,
      benefit: I18N.benefitTrio || ((_names.pure || 'Collagène Marin') + ' + Vitamine C + Biotine — la routine beauté complète.'),
      price: _prices.trio || '80,00 $',
      compareAtPrice: _compare.trio || null,
      image: _imgs.trio || null,
      url: _urls.trio || '/fr-ca/products/trio-beaute-collagene-marin-vitamine-c-et-biotine',
    },
    electrolytes: {
      variantId: _vids.electrolytes || null,
      name: 'Électrolytes',
      benefit: I18N.benefitElectrolytes || 'Hydratation & récupération sportive optimales.',
      price: null,
      image: _imgs.electrolytes || null,
      url: '/fr-ca/products/electrolytes',
    },
    duo: {
      variantId: _vids.duo || null,
      name: _names.duo,
      benefit: I18N.benefitDuo || ((_names.pure || 'Collagène Marin') + ' + ' + (_names.energie || 'Collagène Énergie') + ' — la combinaison idéale pour profiter des deux formules.'),
      price: _prices.duo || null,
      compareAtPrice: _compare.duo || null,
      image: _imgs.duo || null,
      url: _urls.duo || '/fr-ca/products/duo-collagene-marin-pure-et-energie',
    },
    serenite: {
  variantId: _vids.serenite || null,
  name: _names.serenite,
  benefit: I18N.benefitSerenite || 'Favorise le sommeil et la détente — camomille et mélisse, saveur framboise, yuzu et menthe.',
  price: _prices.serenite || '80,00 $',
  compareAtPrice: _compare.serenite || null,
  image: _imgs.serenite || null,
  url: _urls.serenite || '/fr-ca/products/collagene-marin-serenite',
},
pureSachets: {
  variantId: _vids.pureSachets || null,
  name: _names.pureSachets,
  benefit: I18N.benefitPureSachets || 'Le même collagène PURE, en sachets individuels — parfait à emporter.',
  price: _prices.pureSachets || '80,00 $',
  compareAtPrice: _compare.pureSachets || null,
  image: _imgs.pureSachets || null,
  url: _urls.pureSachets || '/fr-ca/products/collagene-marin-pure-boite-de-30-sachets',
},
energieSachets: {
  variantId: _vids.energieSachets || null,
  name: _names.energieSachets,
  benefit: I18N.benefitEnergieSachets || 'Le même collagène ÉNERGIE, en sachets individuels — parfait à emporter.',
  price: _prices.energieSachets || '80,00 $',
  compareAtPrice: _compare.energieSachets || null,
  image: _imgs.energieSachets || null,
  url: _urls.energieSachets || '/fr-ca/products/collagene-marin-energie-boite-de-30-sachets',
},
  };

  var overlay, modal, progressFill, progressLabel;

  function init() {
    overlay       = document.getElementById('mcs-quiz-overlay');
    modal         = document.getElementById('mcs-quiz-modal');
    progressFill  = document.getElementById('mcs-quiz-progress-fill');
    progressLabel = document.getElementById('mcs-quiz-progress-label');

    if (!overlay) return;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-mcs-quiz-open]');
      if (btn) openQuiz({ currentTarget: btn });
    });

    var closeBtn = document.getElementById('mcs-quiz-close');
    if (closeBtn) closeBtn.addEventListener('click', closeQuiz);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeQuiz();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeQuiz();
    });

    var startBtn = document.getElementById('mcs-quiz-start');
    if (startBtn) startBtn.addEventListener('click', function () { goToStep(1); });

    bindSingleSelect('step-1', 'genre',       'mcs-quiz-step-1');
    bindSingleSelect('step-2', 'age',         'mcs-quiz-step-2');
    bindMultiSelect('step-3',  'priorite',    'mcs-quiz-step-3');
    bindMultiSelect('step-4',  'integration', 'mcs-quiz-step-4');
    bindMultiSelect('step-5',  'moment',      'mcs-quiz-step-5');
    bindMultiSelect('step-6',  'routine',     'mcs-quiz-step-6');

    var prenomInput = document.getElementById('mcs-quiz-prenom');
    var emailInput  = document.getElementById('mcs-quiz-email');
    var optinInput  = document.getElementById('mcs-quiz-optin');

    if (prenomInput) prenomInput.addEventListener('input', function (e) { state.answers.prenom = e.target.value.trim(); });
    if (emailInput)  emailInput.addEventListener('input',  function (e) { state.answers.email  = e.target.value.trim(); });
    if (optinInput)  optinInput.addEventListener('change', function (e) { state.answers.optin  = e.target.checked; });

    document.querySelectorAll('[data-mcs-next]').forEach(function (btn) {
      btn.addEventListener('click', function () { goToStep(parseInt(this.dataset.mcsNext, 10)); });
    });
    document.querySelectorAll('[data-mcs-back]').forEach(function (btn) {
      btn.addEventListener('click', function () { goToStep(parseInt(this.dataset.mcsBack, 10)); });
    });

    var submitBtn = document.getElementById('mcs-quiz-submit');
    if (submitBtn) submitBtn.addEventListener('click', submitQuiz);

    var skipEmailBtn = document.getElementById('mcs-quiz-skip-email');
    if (skipEmailBtn) skipEmailBtn.addEventListener('click', function () {
      state.recommendation = calculateRecommendation();
      try { localStorage.setItem('mcs_quiz', JSON.stringify({ priorite: state.answers.priorite, age: state.answers.age, rec: state.recommendation.primary, date: new Date().toISOString() })); } catch (e) {}
      renderResults(state.recommendation);
      goToStep(8);
    });

    var restartBtn = document.getElementById('mcs-quiz-restart');
    if (restartBtn) restartBtn.addEventListener('click', function () { resetQuiz(); goToStep(0); });
  }

  function openQuiz(e) {
    var btn = e && e.currentTarget;
    if (btn && window.MCSQuizConfig) {
      var d = btn.dataset;
      if (d.mcsKlavKey)  window.MCSQuizConfig.klaviyoKey    = d.mcsKlavKey;
      if (d.mcsKlavList) window.MCSQuizConfig.klaviyoListId = d.mcsKlavList;
    }
    resetQuiz();
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    goToStep(0);
  }

  function closeQuiz() {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function goToStep(n) {
    document.querySelectorAll('.mcs-quiz-step').forEach(function (s) { s.classList.remove('is-active'); });
    var target = document.getElementById('mcs-quiz-step-' + n);
    if (target) {
      target.classList.add('is-active');
      state.currentStep = n;
      updateProgress(n);
      if (modal) modal.scrollTop = 0;
    }
  }

  function updateProgress(step) {
    if (!progressFill) return;
    var pct = (step > 0 && step < 8) ? Math.round(((step - 1) / state.totalSteps) * 100) : (step === 8 ? 100 : 0);
    progressFill.style.width = pct + '%';
    if (progressLabel) {
      if (step <= 0 || step >= 7) { progressLabel.classList.add('is-hidden'); } else { progressLabel.classList.remove('is-hidden'); }
      var cur = progressLabel.querySelector('.mcs-step-current');
      if (cur) cur.textContent = step;
    }
  }

  function bindSingleSelect(stepId, answerKey, containerId) {
    var container = document.getElementById(containerId);
    if (!container) return;
    container.querySelectorAll('.mcs-quiz-card').forEach(function (card) {
      card.addEventListener('click', function () {
        container.querySelectorAll('.mcs-quiz-card').forEach(function (c) { c.classList.remove('is-selected'); });
        this.classList.add('is-selected');
        state.answers[answerKey] = this.dataset.value;
        updateNextBtn(stepId);
      });
    });
  }

  function bindMultiSelect(stepId, answerKey, containerId) {
    var container = document.getElementById(containerId);
    if (!container) return;
    container.querySelectorAll('.mcs-quiz-card').forEach(function (card) {
      card.addEventListener('click', function () {
        var val = this.dataset.value;
        if (this.classList.contains('is-selected')) {
          this.classList.remove('is-selected');
          state.answers[answerKey] = state.answers[answerKey].filter(function (v) { return v !== val; });
        } else {
          this.classList.add('is-selected');
          if (!Array.isArray(state.answers[answerKey])) state.answers[answerKey] = [];
          state.answers[answerKey].push(val);
        }
        updateNextBtn(stepId);
      });
    });
  }

  function updateNextBtn() {
    // All steps are always skippable — nothing to disable
  }

  function isValidEmail(email) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email); }

  function calculateRecommendation() {
    var scores = { pure: 0, energie: 0, trio: 0, serenite: 0 };
    ['genre', 'age', 'priorite', 'integration', 'moment', 'routine'].forEach(function (key) {
      var val = state.answers[key];
      if (!val || (Array.isArray(val) && val.length === 0)) return;
      var vals = Array.isArray(val) ? val : [val];
      vals.forEach(function (v) {
        if (scoringRules[key] && scoringRules[key][v]) {
          var r = scoringRules[key][v];
          Object.keys(r).forEach(function (k) { if (scores[k] !== undefined) scores[k] += r[k]; });
        }
      });
    });
    var sorted = Object.keys(scores).sort(function (a, b) { return scores[b] - scores[a]; });
    var primary = (scores[sorted[0]] === scores[sorted[1]]) ? 'trio' : sorted[0];
    return { primary: primary, secondary: primary === 'pure' ? 'duo' : null };
  }

  function submitQuiz() {
    var btn = document.getElementById('mcs-quiz-submit');
    btn.textContent = I18N.loading || 'Un moment…';
    btn.disabled = true;
    state.recommendation = calculateRecommendation();
    try { localStorage.setItem('mcs_quiz', JSON.stringify({ priorite: state.answers.priorite, age: state.answers.age, rec: state.recommendation.primary, date: new Date().toISOString() })); } catch (e) {}
    var done = function () { renderResults(state.recommendation); goToStep(8); btn.textContent = I18N.seeResults || 'Voir mes résultats'; btn.disabled = false; };
    var kKey  = (window.MCSQuizConfig && window.MCSQuizConfig.klaviyoKey)   || klaviyoPublicKey;
    var kList = (window.MCSQuizConfig && window.MCSQuizConfig.klaviyoListId) || klaviyoListId;
    if (kKey && kList && isValidEmail(state.answers.email)) {
      var profileAttrs = {
        email: state.answers.email,
        properties: {
          quiz_sexe:                state.answers.genre,
          quiz_age:                 state.answers.age,
          quiz_priorite:            state.answers.priorite,
          quiz_integration:         state.answers.integration,
          quiz_moment:              state.answers.moment,
          quiz_resultats_souhaites: state.answers.routine,
          quiz_optin:               state.answers.optin,
          quiz_recommandation:      state.recommendation.primary
        },
        subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
      };
      if (state.answers.prenom) profileAttrs.first_name = state.answers.prenom;
      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Quiz MCS',
            profile: { data: { type: 'profile', attributes: profileAttrs } }
          },
          relationships: { list: { data: { type: 'list', id: kList } } }
        }
      };
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + kKey, {
        method: 'POST',
        headers: { 'content-type': 'application/vnd.api+json', 'revision': '2026-04-15' },
        body: JSON.stringify(payload),
      }).then(function (res) {
        if (!res.ok) res.text().then(function (t) { console.error('[MCS Quiz] Klaviyo erreur', res.status, t); });
        done();
      }).catch(function (err) {
        console.error('[MCS Quiz] Klaviyo fetch error:', err);
        done();
      });
    } else { done(); }
  }
function getDisplayKey(key) {
  var portable = Array.isArray(state.answers.integration) && state.answers.integration.indexOf('emporter') !== -1;
  if (portable && key === 'pure' && products.pureSachets) return 'pureSachets';
  if (portable && key === 'energie' && products.energieSachets) return 'energieSachets';
  return key;
}
function renderResults(rec) {
  var container = document.getElementById('mcs-quiz-results-products');
  if (!container) return;
  var titleEl = document.getElementById('mcs-quiz-results-title');
  if (titleEl) titleEl.textContent = state.answers.prenom ? (I18N.resultsTitleNamed || 'Votre routine, ') + state.answers.prenom : (I18N.resultsTitle || 'Votre routine personnalisée');
  container.innerHTML = '';
  var primaryKey = getDisplayKey(rec.primary);   // changed
  if (products[primaryKey]) container.appendChild(buildCard(products[primaryKey], true));
  if (rec.secondary && products[rec.secondary]) container.appendChild(buildCard(products[rec.secondary], false));
}

  function buildCard(prod, isPrimary) {
    var div = document.createElement('div');
    div.className = 'mcs-quiz-product-card' + (isPrimary ? ' is-primary' : '');
    var imgSrc = prod.image || 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="80" height="80"%3E%3Crect width="80" height="80" fill="%23f5f5f5"/%3E%3C/svg%3E';

    var priceDisplayId = 'mcs-quiz-price-' + (isPrimary ? 'primary' : 'secondary');
    var actionsHtml;
    var priceHtml;

    if (prod.variants && prod.variants.length > 1) {
      var firstV = prod.variants[0];
      priceHtml = firstV.compare_at_price
        ? '<s class="mcs-quiz-price-compare">' + firstV.compare_at_price + '</s><span class="mcs-quiz-price-sale">' + firstV.price + '</span>'
        : firstV.price;
      var pillsHtml = prod.variants.map(function (v, i) {
        return '<button class="mcs-quiz-variant-pill' + (i === 0 ? ' is-selected' : '') + '"' +
          ' data-variant-id="' + v.id + '"' +
          ' data-price="' + v.price + '"' +
          ' data-compare-at="' + (v.compare_at_price || '') + '">' +
          v.title + '</button>';
      }).join('');
      actionsHtml =
        '<div class="mcs-quiz-variant-pills">' + pillsHtml + '</div>' +
        '<div class="mcs-quiz-product-price" id="' + priceDisplayId + '">' + priceHtml + '</div>' +
        '<button class="mcs-quiz-btn-cart">' + (I18N.addToCart || 'Ajouter au panier') + '</button>';
    } else {
      var rawPrice = prod.price || '';
      priceHtml = (prod.compareAtPrice && rawPrice)
        ? '<s class="mcs-quiz-price-compare">' + prod.compareAtPrice + '</s><span class="mcs-quiz-price-sale">' + rawPrice + '</span>'
        : rawPrice;
      actionsHtml =
        (priceHtml ? '<div class="mcs-quiz-product-price" id="' + priceDisplayId + '">' + priceHtml + '</div>' : '') +
        (prod.variantId ? '<button class="mcs-quiz-btn-cart" data-variant-id="' + prod.variantId + '">' + (I18N.addToCart || 'Ajouter au panier') + '</button>' : '');
    }

    div.innerHTML =
      '<a href="' + prod.url + '" class="mcs-quiz-product-img-link">' +
        '<img class="mcs-quiz-product-img" src="' + imgSrc + '" alt="' + prod.name + '" loading="lazy">' +
      '</a>' +
      '<div class="mcs-quiz-product-info">' +
        '<div class="mcs-quiz-product-name">' + prod.name + '</div>' +
        '<div class="mcs-quiz-product-benefit">' + prod.benefit + '</div>' +
        '<div class="mcs-quiz-product-actions">' + actionsHtml + '</div>' +
      '</div>';

    var pillsContainer = div.querySelector('.mcs-quiz-variant-pills');
    var priceEl = div.querySelector('[id="' + priceDisplayId + '"]');
    if (pillsContainer && priceEl) {
      pillsContainer.querySelectorAll('.mcs-quiz-variant-pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          pillsContainer.querySelectorAll('.mcs-quiz-variant-pill').forEach(function (p) { p.classList.remove('is-selected'); });
          pill.classList.add('is-selected');
          var cap = pill.dataset.compareAt;
          priceEl.innerHTML = cap
            ? '<s class="mcs-quiz-price-compare">' + cap + '</s><span class="mcs-quiz-price-sale">' + pill.dataset.price + '</span>'
            : pill.dataset.price;
        });
      });
    }

    div.querySelectorAll('.mcs-quiz-btn-cart').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId;
        if (btn.dataset.variantId) {
          variantId = parseInt(btn.dataset.variantId);
        } else {
          var card = btn.closest('.mcs-quiz-product-card');
          var selectedPill = card ? card.querySelector('.mcs-quiz-variant-pill.is-selected') : null;
          variantId = selectedPill ? parseInt(selectedPill.dataset.variantId) : null;
        }
        addToCart(variantId, btn);
      });
    });
    return div;
  }

  function addToCart(variantId, btn) {
    if (!variantId) return;
    btn.textContent = '…'; btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: variantId, quantity: 1 }) })
      .then(function (res) { if (res.ok) { btn.textContent = I18N.added || '✓ Ajouté !'; btn.classList.add('added'); document.dispatchEvent(new CustomEvent('cart:refresh')); } else { btn.textContent = I18N.addToCart || 'Ajouter au panier'; btn.disabled = false; } })
      .catch(function () { btn.textContent = I18N.addToCart || 'Ajouter au panier'; btn.disabled = false; });
  }

  function resetQuiz() {
    state.answers = { genre: null, age: null, priorite: [], integration: [], moment: [], routine: [], prenom: '', email: '', optin: false };
    state.recommendation = null;
    document.querySelectorAll('.mcs-quiz-card.is-selected').forEach(function (c) { c.classList.remove('is-selected'); });
    var ef = document.getElementById('mcs-quiz-email');   if (ef) ef.value = '';
    var pf = document.getElementById('mcs-quiz-prenom');  if (pf) pf.value = '';
    var of = document.getElementById('mcs-quiz-optin');   if (of) of.checked = false;
    var rc = document.getElementById('mcs-quiz-results-products'); if (rc) rc.innerHTML = '';
    // next buttons remain enabled — all steps are optional
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
